import S_base from '@/services/wasaapi/__base';

export default {
  async index(answerSettingId) {
    const params = {
      order_by: 'sequence',
      order_way: 'asc',
    };
    const res = await S_base.index({
      parentName: 'answr_setting',
      parentId: answerSettingId,
      modelName: 'index/all',
      params
    });
    return res;
  }
}